/** Danger zone section — account deletion, gated by a confirmation modal. */
import { useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/interfaces/learner/ui';
import { DeleteAccountModal } from '@/shared/auth/DeleteAccountModal';
import { SettingsSection } from './SettingsSection';

export default function DangerZoneSection() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <SettingsSection title="Danger zone" delay={0.3} variant="danger">
      <div className="flex items-start gap-3">
        <AlertTriangle
          size={18}
          strokeWidth={2}
          className="shrink-0 mt-0.5"
          style={{ color: 'var(--color-error-text)' }}
        />
        <div className="flex-1">
          <p className="text-list-title">Delete account</p>
          <p className="text-meta-muted mt-1">
            Permanently delete your account and all associated data. This action cannot be undone.
          </p>
          <div className="mt-4">
            <Button variant="danger" size="sm" onPress={() => setModalOpen(true)}>
              Delete account
            </Button>
          </div>
        </div>
      </div>
      <DeleteAccountModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </SettingsSection>
  );
}
